/**
 * The origin this storefront is actually served from — the single source of
 * truth for canonical, og:url, og:image, sitemap and robots.txt URLs.
 *
 * This lives in a `.cjs` so the build-time config files (gatsby-config.js,
 * gatsby-node.js) and the browser bundle can all share one definition.
 * Repeating the fallback in each of them is exactly how they drift apart.
 *
 * It is deliberately NOT GATSBY_TTF_SITE_URL: that value is sent to the API as
 * the `Origin` header and is registered backend-side, so it is not free to
 * follow wherever the public site is hosted. The two can legitimately differ —
 * a storefront on a subdomain of a separate marketing site, for instance.
 *
 * There is no trailing slash; callers append a path that starts with one.
 */
const CANONICAL_ORIGIN = (
  process.env.GATSBY_TTF_CANONICAL_ORIGIN ||
  process.env.GATSBY_TTF_SITE_URL ||
  "https://events.tfsports.eu"
).replace(/\/+$/, "")

module.exports = { CANONICAL_ORIGIN }
